module.exports = __webpack_public_path__ + "static/media/pin.7722f0fb.png";